import React, { useEffect } from "react";
// eslint-disable-next-line import/no-unresolved
import { AddLimitRequestConfirmation as AddLimitRequestConfirmationUI, Box } from "@ui-kit/components/index.es";
import Head from "pages/_components/Head";
import Notification from "pages/_components/Notification";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { push, replace } from "react-router-redux";
import { actions as addLimitRequestActions, selectors as addLimitRequestSelectors } from "reducers/addLimitRequest";
import * as i18n from "util/i18n";
import { resolveAddLimitGoBackTarget } from "util/addLimitRequestNavigation";
import "./AddLimitRequestConfirmation.scss";
import { resizableRoute } from "pages/_components/Resizable";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";
import * as configUtils from "util/config";


const FORM_ID = "addLimitRequest.confirmation";

const AddLimitRequestConfirmation = (props) => {
    const { isDesktop, dispatch, isFetching, requestData, embeddedInV3Shell, location, navigationPrevPath } = props;

    const data = requestData || {};

    const resolveExitTarget = () => resolveAddLimitGoBackTarget(location, navigationPrevPath);

    useEffect(() => {
        if (!requestData) {
            dispatch(replace(resolveExitTarget()));
        }
    }, []);

    useEffect(() => {
        if (!embeddedInV3Shell || !requestData) {
            return undefined;
        }
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["addLimitRequestConfirmation"],
            titleKey: `${FORM_ID}.title`,
            goBackPath: "/v2/addlimitrequest",
        });
        return () => {
            clearEmbeddedV3ShellLayoutState(dispatch);
        };
    }, [dispatch, embeddedInV3Shell, isDesktop, requestData]);

    const handleBack = () => {
        if (requestData) {
            dispatch(push("/v2/addlimitrequest"));
            return;
        }
        dispatch(push(resolveExitTarget()));
    };

    const getLabels = (id) => {
        const defaultLabels = {
            motive: "MOTIVO",
            temporaryLimit: "LIMITE TEMPORAL",
            duration: "DURACIÓN LÍMITE TEMPORAL",
            confirm: "Confirmar",
        };
        return i18n.get(`${FORM_ID}.${id}`, defaultLabels[id] || id);
    };

    const handleConfirm = () => {
        dispatch(addLimitRequestActions.submitRequest(requestData));
    };

    return (
        <>
            {!embeddedInV3Shell && (
                <Notification
                    scopeToShow="addLimitRequestConfirmation"
                    notificationClassname={!isDesktop ? "z-index-9" : ""}
                />
            )}
            <div className={`admin-detail-head ${isDesktop ? "px-4" : "d-block"}`}>
                {(!embeddedInV3Shell || isDesktop) && (
                    <>
                        {isDesktop && <Head onBack={handleBack} />}
                        <Head
                            accessibilityTextId="addLimitRequest.confirmation.title"
                            headerClassName={
                                !isDesktop
                                    ? "blue-main-header-mobile blue-main-title-mobile background-transparent"
                                    : ""
                            }
                            titleText={i18n.get(`${FORM_ID}.title`)}
                            titleClassName={
                                !isDesktop
                                    ? "header-mobile-title-background-blue white-space-normal align-center"
                                    : undefined
                            }
                            centerContentClassName={!isDesktop ? "view-title-narrow" : undefined}
                            onBack={!isDesktop && handleBack}
                            hasInlineButtons
                        />
                    </>
                )}
                <Box mt={isDesktop ? 32 : 0}>
                    <div className="confirmation-labels-normal">
                        <AddLimitRequestConfirmationUI
                            motive={data.motive}
                            temporaryLimit={data.temporaryLimit}
                            currency={data.currency}
                            duration={data.duration}
                            getLabels={getLabels}
                            confirmationText={i18n.get(`${FORM_ID}.text`)}
                            subtitle={i18n.get(`${FORM_ID}.subtitle`, "Controlá los datos y confirmala")}
                            hintText={configUtils.get("frontend.text.temporarilyincreaselimit")}
                            loading={isFetching}
                            handleConfirm={handleConfirm}
                        />
                    </div>
                </Box>
            </div>
        </>
    );
};

AddLimitRequestConfirmation.propTypes = {
    isDesktop: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
    isFetching: PropTypes.bool,
    embeddedInV3Shell: PropTypes.bool,
    location: PropTypes.shape({
        pathname: PropTypes.string,
        state: PropTypes.shape({}),
    }),
    navigationPrevPath: PropTypes.string,
    requestData: PropTypes.shape({
        motive: PropTypes.string,
        motiveValue: PropTypes.string,
        temporaryLimit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        currency: PropTypes.string,
        currencyValue: PropTypes.string,
        duration: PropTypes.string,
        durationValue: PropTypes.string,
    }),
};

AddLimitRequestConfirmation.defaultProps = {
    isFetching: false,
    requestData: null,
    embeddedInV3Shell: false,
    location: undefined,
    navigationPrevPath: null,
};

const mapStateToProps = (state) => ({
    requestData: addLimitRequestSelectors.getRequestData(state),
    isFetching: addLimitRequestSelectors.getFetching(state),
    navigationPrevPath: addLimitRequestSelectors.getPrevPath(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(AddLimitRequestConfirmation);
